<template>
  <a
    class="text-link--primary flex items-center font-bold text-sm leading-3.5"
    :href="qr && qr.toDataURL()"
    download="ahaslides-qrcode.png"
  >
    <slot />
  </a>
</template>

<script>
import QrCode from './QrCode.vue'

export default {
  mixins: [QrCode],
}
</script>
